import type { FaireProductEntity } from "../../entity_types/product";

export const p_1ib4ie8e: FaireProductEntity = {
  token: "p_1ib4ie8e",
  type: "product",
  name: "Mamacita - Letterpress Mother's Day Greeting Card",
  brandToken: "b_a55ea308",
  brandName: "Dahlia Press",
  imageUrl:
    "https://cdn.faire.com/fastly/6615c8da78ebb497f444b0984ddda09cca40636bab5fd86ef3da6e79c2f4eec8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/deeb1cb3d554e859ba20eef8ff16ca614289f9dbf107ead9e0a881b6927ea470.jpeg",
  ],
  priceDollars: 4.11,
  description:
    'MAKE MOM SMILE WITH THIS SWEET GREETING!\nThis charming Mother\'s Day card features a simple yet stylish design with the word "Mamacita" in bold red handwriting. With a minimalist aesthetic, this card serves as the perfect base for your own personal message of appreciation. It’s sure to become a cherished keepsake that your beloved Mamacita will treasure for years to come.\n\nBlank inside for your personal message, this greeting is hand illustrated, letterpress printed on plush paper and comes with a coordinating blush envelope.\n\nincludes: 1 card + 1 envelope // size: 4.25 x 5.5" folded // packaging: cellophane sleeve // interior: blank // minimum: 6 per design style // Made in the USA',
  tags: [],
  msrpDollars: 8.22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:33.948Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
